import React from 'react';
import { FeedbackVariants } from '@indigo-ag/component-module/dist/commonjs/shared/theme/theme-helpers/feedback';
import { SerasaRestrictionsDetailModal } from './SerasaRestrictionsDetailModal';
import i18next from 'i18next';
import { SerasaApiStatus } from '@indigo-ag/schema';
import { SerasaItem } from '../../../../phases/Phase1.utils';
import { SerasaBacenCard } from '../SerasaBacenCard';

interface SerasaAnnotationCardProps {
  annotationType: string;
  report: SerasaItem;
}

const STATUS_LABEL_MAP: { [key in SerasaApiStatus]: string } = {
  UNRESOLVED: i18next.t('backgroundCheckStepStatus_Failed'),
  FAILED: i18next.t('backgroundCheckStepStatus_Failed'),
  CLEARED: i18next.t('backgroundCheckStepStatus_Passed')
};

const VARIANT_STATUS_MAP: { [key in SerasaApiStatus]: FeedbackVariants } = {
  UNRESOLVED: 'warning',
  FAILED: 'error',
  CLEARED: 'success'
};

const MESSAGE_MAP: { [key in SerasaApiStatus]: string } = {
  CLEARED: i18next.t('serasaAnnotationCard_message'),
  FAILED: i18next.t('serasaAnnotationCard_messageFailed'),
  UNRESOLVED: i18next.t('serasaAnnotationCard_messageEmpty')
};

export const SerasaAnnotationCard = ({ annotationType, report }: SerasaAnnotationCardProps) => {
  const occurrences = report?.occurrences ? [...report.occurrences] : [];
  const status = report.status as SerasaApiStatus;

  const showDetailModal = (isOpen: boolean, onRequestClose: () => void) => (
    <SerasaRestrictionsDetailModal isOpen={isOpen} onRequestClose={onRequestClose} occurrences={occurrences ?? []} />
  );

  return (
    <SerasaBacenCard
      report={{
        annotationType,
        date: report.dateReport,
        statusMessage: MESSAGE_MAP[status]
      }}
      statusTag={{
        label: STATUS_LABEL_MAP[status],
        variant: VARIANT_STATUS_MAP[status]
      }}
      modal={{ show: showDetailModal }}
      restriction={occurrences.length === 0}
    />
  );
};
